module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門1_8.df0e15f0.png";